export default "__VITE_ASSET__CNgGE090__"